import React, { useEffect, useState } from "react";
import {
  Box,
  Flex,
  VStack,
  HStack,
  Text,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  useColorModeValue,
  Container,
  Heading,
} from "@chakra-ui/react";
import { BsPerson, BsCreditCard } from "react-icons/bs";
import { RiUserFollowLine } from "react-icons/ri";
import { usePayment } from "../../contexts/PaymentContext";
import { useDispatch, useSelector } from "react-redux";
import { getUserOrders } from "../../actions/order/orderActions";
import Loader from "../../components/Loader/Loader";

const Payments = () => {
  const dispatch = useDispatch();
  const { showPaymentModal } = usePayment();
  const [currentPlan, setCurrentPlan] = useState({});
  const { loading: orderLoading, data: orderData } = useSelector(
    (state) => state.orderReducer
  );
  const bgColor = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.600");

  useEffect(() => {
    if (!orderLoading && orderData) {
      setCurrentPlan(orderData.find((order) => order.isActive === true));
    }
  }, [orderLoading]);

  useEffect(() => {
    dispatch(getUserOrders());
  }, []);

  return (
    <Box minH="100vh" bg={useColorModeValue("gray.50", "gray.900")}>
      <Box alignItems={"end"}>
        <Button mt={6} colorScheme="gray" onClick={() => showPaymentModal()}>
          Proceed To Buy
        </Button>
      </Box>
      <Flex direction={{ base: "column", md: "row" }}>
        {/* Main Content */}

        <Box flex={1} p={{ base: 4, md: 8 }}>
          <Container maxW="container.xl">
            {/* Current Plan Section */}
            <Box bg={bgColor} borderRadius="lg" boxShadow="md" p={6} mb={8}>
              <Heading size="md" mb={6}>
                Current Plan
              </Heading>
              <VStack
                spacing={4}
                align="stretch"
                divider={<Box borderBottom="1px" borderColor={borderColor} />}
              >
                <HStack justifyContent="space-between">
                  <Text fontWeight="medium">Plan Name</Text>
                  <Text>{currentPlan?.paymentPlanId?.planName.label}</Text>
                </HStack>
                <HStack justifyContent="space-between">
                  <Text fontWeight="medium">Billing Date</Text>
                  <Text>{currentPlan?.createdAt}</Text>
                </HStack>
                <HStack justifyContent="space-between">
                  <Text fontWeight="medium">End On</Text>
                  <Text>{currentPlan?.endDate}</Text>
                </HStack>
                <HStack justifyContent="space-between">
                  <Text fontWeight="medium">Price</Text>
                  <Text>{currentPlan?.amount}</Text>
                </HStack>
                <HStack justifyContent="space-between">
                  <Text fontWeight="medium">Method</Text>
                  <Text>{currentPlan?.paymentMethod}</Text>
                </HStack>
              </VStack>
              <Button mt={6} colorScheme="gray" w="full">
                Change Plan
              </Button>
            </Box>

            {/* Transaction History Section */}
            <Box bg={bgColor} borderRadius="lg" boxShadow="md" p={6}>
              <Heading size="md" mb={6}>
                Transaction History
              </Heading>
              <TableContainer>
                <Table variant="simple">
                  <Thead>
                    <Tr>
                      <Th>Plan Name</Th>
                      <Th>Billing Date</Th>
                      <Th>Payment Method</Th>
                      <Th>Payment Status</Th>
                      <Th isNumeric>Total Amount</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {orderLoading || !orderData ? (
                      <Loader />
                    ) : (
                      orderData.map((transaction, index) => (
                        <Tr key={index}>
                          <Td>{transaction?.paymentPlanId?.planName.label}</Td>
                          <Td>{transaction.createdAt}</Td>
                          <Td>{transaction.paymentMethod}</Td>
                          <Td>{transaction.status}</Td>
                          <Td isNumeric>₹ {transaction.amount}</Td>
                        </Tr>
                      ))
                    )}
                  </Tbody>
                </Table>
              </TableContainer>
            </Box>
          </Container>
        </Box>
      </Flex>
    </Box>
  );
};

export default Payments;
